import { cn } from '@/utils/cn';
import type { DentalShortcutRow } from '@/hooks/useDentalShortcuts';

interface ShortcutButtonProps {
  shortcut: DentalShortcutRow;
  isActive: boolean;
  onClick: (shortcut: DentalShortcutRow) => void;
  tooltipName?: string;
}

export function ShortcutButton({ shortcut, isActive, onClick, tooltipName }: ShortcutButtonProps) {
  const title = tooltipName
    ? `${shortcut.label} (${shortcut.procedure_code}): ${tooltipName}`
    : `${shortcut.label} — ${shortcut.procedure_code}`;

  return (
    <button
      type="button"
      title={title}
      onClick={() => onClick(shortcut)}
      className={cn(
        'relative w-full rounded-lg px-1.5 py-1.5 text-center text-xs font-semibold text-white',
        'transition-all duration-100 select-none',
        'hover:brightness-110 active:scale-95',
        isActive && 'ring-2 ring-offset-2 ring-ds-text',
      )}
      style={{ backgroundColor: shortcut.color }}
      aria-pressed={isActive}
    >
      <span className="line-clamp-2 leading-tight">{shortcut.label}</span>
    </button>
  );
}
